<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addDepartment" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加部门</el-button>
      </div>
      <!--      </el-form>-->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column prop="departmentName" label="部门名称" show-overflow-tooltip width="250" align="center" />
          <el-table-column label="绑定教师" align="center">
            <template slot-scope="{ row }">
              <el-tag v-for="(item, index) in row.teacherList" :key="item.id" :style="{ 'margin-left': index > 0 ? '5px' : '' }"
                >{{ item.teacherName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="250">
            <template #default="{ row }">
              <el-link @click="editDepartment(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
              <el-link @click="openBindTeacher(row)" icon="el-icon-paperclip" type="primary" :underline="false">绑定教师</el-link>
              <el-popconfirm title="确定要删除此部门吗？" @onConfirm="deleteDepartment(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改部门' : '添加部门'"
      :visible.sync="showEdit"
      width="400px"
      @closed="resetForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="部门名称:" prop="departmentName">
          <el-input v-model="editForm.departmentName" placeholder="请输入部门名称" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveDepartment()">保存</el-button>
      </div>
    </el-dialog>
    <!--绑定教师-->
    <el-dialog
      title="绑定教师"
      :visible.sync="showBind"
      width="600px"
      @closed="teacherIds = []"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="bindForm" ref="bindForm" :rules="bindRules" label-width="85px">
        <el-form-item label="选择老师:">
          <treeselect
            v-model="bindForm.teacherIds"
            :options="deptTeacher"
            :disable-branch-nodes="true"
            placeholder="请选择老师"
            :defaultExpandLevel="2"
            :multiple="true"
            search-nested
            noChildrenText="该部门无人员"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
            style="line-height: 20px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showBind = false">取消</el-button>
        <el-button type="primary" @click="bindTeacher">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import { delConfig, saveConfig, addBindingTeacher, getBindingTeacherIds } from '@/config/fengyi/department';
  import { getAllDepartTeachers } from '@/config/api';

  export default {
    name: 'department',
    components: { Treeselect },
    data() {
      return {
        table: {
          // 表格配置
          url: '/fyOpinion/configList',
          method: 'GET',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        data: null,
        choose: [],
        editForm: {
          departmentName: '',
        },
        editRules: {
          departmentName: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
        },
        showEdit: false,
        teacherIds: [],
        showBind: false,
        deptTeacher: [],
        bindForm: {},
        bindRules: {
          teacherIds: [{ required: true, message: '请选择老师', trigger: 'change' }],
        },
      };
    },
    methods: {
      // 打开添加部门弹窗
      addDepartment() {
        this.showEdit = true;
      },
      // 编辑部门
      editDepartment(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      // 保存或更新
      saveDepartment() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveConfig(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除部门
      deleteDepartment(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        delConfig(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 重置表单
      resetForm() {
        this.editForm = {
          departmentName: '',
        };
        this.$refs['editForm'].resetFields();
      },
      // 打开绑定教师弹窗
      openBindTeacher(row) {
        this.querydeptTeacher();
        this.bindForm.id = row.id;
        this.bindForm.teacherIds = row.teacherIds;
        this.showBind = true;
      },
      /* 获取所有部门下的所有老师 树 */
      querydeptTeacher() {
        getAllDepartTeachers().then((res) => {
          if (res.data.resCode == 200) {
            this.deptTeacher = res.data.data;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 保存绑定教师
      bindTeacher() {
        this.$refs['bindForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.bindForm) {
              if (this.bindForm[key] !== null && this.bindForm[key] !== undefined) {
                formData.append(key, this.bindForm[key]);
              }
            }
            addBindingTeacher(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showBind = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          }
        });
      },
    },
  };
</script>

<style scoped lang="scss"></style>
